<template>
  <a-drawer
    :title="title"
    :width="width"
    placement="right"
    :closable="false"
    @close="close"
    :visible="visible">
  
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="发布编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['publishCode']" placeholder="请输入发布编号"></a-input>
        </a-form-item>
        <a-form-item label="商品信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['productInfo', validatorRules.productInfo]" placeholder="请输入商品信息"></a-input>
        </a-form-item>
        <a-form-item label="商品发布名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['publishProdName', validatorRules.publishProdName]" placeholder="请输入商品发布名称"></a-input>
        </a-form-item>
        <a-form-item label="商品发布简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-decorator="['publishProdDescription', validatorRules.publishProdDescription]" rows="4" placeholder="请输入商品发布简介"/>
        </a-form-item>
        <a-form-item label="所属门店" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['storeId', validatorRules.storeId]" :trigger-change="true" dictCode="sales_physical_store,phystore_name,id" placeholder="请选择所属门店"/>
        </a-form-item>
        <a-form-item label="是否可配送" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['publishIsdelivery', validatorRules.publishIsdelivery]" :trigger-change="true" dictCode="yesorno" placeholder="请选择是否可配送"/>
        </a-form-item>
        <a-form-item label="发布渠道" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-multi-select-tag type="list_multi" v-decorator="['publishChannel', validatorRules.publishChannel]" :trigger-change="true" dictCode="sales_channel,channel_name,id" placeholder="请选择发布渠道"/>
        </a-form-item>
        <a-form-item label="发布状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['publishState', validatorRules.publishState]" :trigger-change="true" dictCode="s_publish_state" placeholder="请选择发布状态"/>
        </a-form-item>
        <a-form-item label="发布时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-date placeholder="请选择发布时间" v-decorator="['publishTime']" :trigger-change="true" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="销售库存" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number v-decorator="['publishProdStock', validatorRules.publishProdStock]" placeholder="请输入销售库存" style="width: 100%"/>
        </a-form-item>
        <a-form-item label="商品规格及单价" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['publishProdSpecs']" placeholder="请输入商品规格及单价"></a-input>
        </a-form-item>
        
      </a-form>
    </a-spin>
    <a-button type="primary" @click="handleOk">确定</a-button>
    <a-button type="primary" @click="handleCancel">取消</a-button>
  </a-drawer>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDate from '@/components/jeecg/JDate'  
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JMultiSelectTag from "@/components/dict/JMultiSelectTag"
  
  export default {
    name: "SalesPublishListModal",
    components: { 
      JDate,
      JDictSelectTag,
      JMultiSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          productInfo: {
            rules: [
              { required: true, message: '请输入商品信息!'},
            ]
          },
          publishProdName: {
            rules: [
              { required: true, message: '请输入商品发布名称!'},
            ]
          },
          publishProdDescription: {
            rules: [
              { required: true, message: '请输入商品发布简介!'},
            ]
          },
          storeId: {
            rules: [
              { required: true, message: '请输入所属门店!'},
            ]
          },
          publishIsdelivery: {
            rules: [
              { required: true, message: '请输入是否可配送!'},
            ]
          },
          publishChannel: {
            rules: [
              { required: true, message: '请输入发布渠道!'},
            ]
          },
          publishState: {
            rules: [
              { required: true, message: '请输入发布状态!'},
            ]
          },
          publishProdStock: {
            rules: [
              { required: true, message: '请输入销售库存!'},
              { pattern: /^-?\d+$/, message: '请输入整数!'},
            ]
          },
        },
        url: {
          add: "/sales/salesPublishList/add",
          edit: "/sales/salesPublishList/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'publishCode','productInfo','publishProdName','publishProdDescription','storeId','publishIsdelivery','publishChannel','publishState','publishTime','publishProdStock','publishProdSpecs'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'publishCode','productInfo','publishProdName','publishProdDescription','storeId','publishIsdelivery','publishChannel','publishState','publishTime','publishProdStock','publishProdSpecs'))
      }
      
    }
  }
</script>

<style lang="less" scoped>
/** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
</style>